import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { ApiHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/api';
import type { CustomerLookup } from '../types/api';
import type { CustomerAddress } from '../types/customer';

/**
 * A service contract to interact with a specific customer's address via the SparkLayer API.
 */
export interface CustomerAddressApiContract {
  get(): Promise<CustomerAddress>;
  update(payload: Partial<CustomerAddress>): Promise<void>;
  delete(): Promise<void>;
}

export class CustomerAddressApi extends ApiService implements CustomerAddressApiContract {
  constructor(
    api: ApiHandlerContract,
    private customerLookup: CustomerLookup,
    private addressLookupId: string,
  ) {
    super(api);
  }

  public get(): Promise<CustomerAddress> {
    return this.api.proxy({
      method: 'GET',
      path: '/v2/customers/{lookupBy}/{identifier}/addresses/{addressId}',
      params: {
        lookupBy: this.customerLookup.by,
        identifier: this.customerLookup.identifier,
        addressId: this.addressLookupId,
      },
    });
  }

  public update(payload: Partial<CustomerAddress>) {
    return this.api.proxy({
      method: 'PATCH',
      path: '/v2/customers/{lookupBy}/{identifier}/addresses/{addressId}',
      payload,
      params: {
        lookupBy: this.customerLookup.by,
        identifier: this.customerLookup.identifier,
        addressId: this.addressLookupId,
      },
    });
  }

  public delete() {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v2/customers/{lookupBy}/{identifier}/addresses/{addressId}',
      params: {
        lookupBy: this.customerLookup.by,
        identifier: this.customerLookup.identifier,
        addressId: this.addressLookupId,
      },
    });
  }
}
